import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { CreateOnsiteInterviewSteps, type TCreateOnsiteInterviewPageLocationState } from '../Types';

interface INavigateToCreateInterviewOptions {
  jobPostingId: string;
  professionalId: string;
  professionalName: string;
}

/**
 * Opens the create-onsite-interview flow for a posting with one professional
 * already invited ("New Interview"). Shared by the job's candidate table
 * (`InviteColumnCell`) and the Candidate Details interviews column, so the
 * route and the location state the Work Details page reads stay in one place.
 */
export const useNavigateToCreateInterview = () => {
  const navigate = useNavigate();

  return useCallback(
    ({ jobPostingId, professionalId, professionalName }: INavigateToCreateInterviewOptions) => {
      const state: TCreateOnsiteInterviewPageLocationState = {
        invitedProfessionals: [{ label: professionalName, value: professionalId }],
      };

      const step = CreateOnsiteInterviewSteps.WorkDetails;

      navigate(`/permanent-jobs/postings/${jobPostingId}/onsite-interviews/create/${step}`, {
        state,
      });
    },
    [navigate],
  );
};
